import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8tt4uz6vzm: FaireBrandEntity = {
  token: "b_8tt4uz6vzm",
  type: "brand",
  name: "Empress Stationery",
  avatarUrl:
    "https://cdn.faire.com/fastly/76376668c5009df6d4479a4a42f725d57c6f19d3d66becc414b51ba5f241dc6d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f4968b122106ac756c52d2e5d1e26730ec35ebd05ff5ae5b0fa3d334cc45bc2d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/76376668c5009df6d4479a4a42f725d57c6f19d3d66becc414b51ba5f241dc6d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4968b122106ac756c52d2e5d1e26730ec35ebd05ff5ae5b0fa3d334cc45bc2d.jpeg",
  location: "Homewood, AL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: true,
  description:
    "Empress Stationery is a boutique paper studio based in Homewood, Alabama, led by husband-and-wife duo Tyler and Jessica Hinton. With roots in luxury wedding stationery, we bring a refined, thoughtful approach to everyday paper goods.\n\nOur collection includes a wide range of paper goods, from antique-inspired notecards to notepads, all designed to feel timeless, giftable, and elevated. Each product is created with attention to detail, quality printing, and a focus on beautiful presentation, making them easy additions for shops looking to offer something both meaningful and well-crafted.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:09.409Z",
    importedBy: "entity-db-cli",
  },
};
